"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultChartDateFormatter = exports.getAxisDomainEnd = exports.getAxisDomainInit = exports.isInsideDomain = exports.getDataPointValue = void 0;
var model_1 = require("./model");
function getDataPointValue(dp) {
    if (typeof dp === 'number')
        return dp;
    else
        return dp.y;
}
exports.getDataPointValue = getDataPointValue;
function isInsideDomain(value, domain) {
    if (Array.isArray(domain))
        return domain.includes(value);
    else
        return +value >= +domain.init && +value <= +domain.end;
}
exports.isInsideDomain = isInsideDomain;
exports.getAxisDomainInit = function (x) {
    return model_1.isValueRange(x) || model_1.isDateRange(x) ? +x.init : x.length && x[0];
};
exports.getAxisDomainEnd = function (x) {
    return model_1.isValueRange(x) || model_1.isDateRange(x) ? +x.end : x.length && x[x.length - 1];
};
exports.defaultChartDateFormatter = function (date) { return date.toLocaleDateString(); };
//# sourceMappingURL=util.js.map